// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip_chip__biwi8","chip--clickable":"Chip_chip--clickable__e1XYp","icon":"Chip_icon__lIU7B","label":"Chip_label__rBWIt","rotation":"Chip_rotation__WwMoP"};